import { toast } from 'react-toastify';
import appApi, {
  CreateDepositPaymentItem,
} from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const addPaymentsToExistingDepositOperation = async (
  depositId: number,
  payments: CreateDepositPaymentItem[],
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  if (!(depositId > 0)) {
    toast.warn('יש לבחור הפקדה');
    return;
  }

  if (!payments || payments.length < 1) {
    toast.warn('יש לבחור לפחות תשלום אחד');
    return;
  }

  try {
    setLoading(true);

    const res = await appApi.addPaymentsToExistingDeposit(depositId, payments);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('התשלומים נוספו להפקדה בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
